import { client } from './automaticCurrencyConversion';
import { v4 as uuid } from 'uuid';
import { Customer } from './customer';
import { airTracker } from '@/utils/airTracker';
import { COMPONENT_NAME } from '@/pages/Main';

interface UpdateIntentRequest {
  customer?: Customer;
  return_url?: string;
}

export const updateIntent = async (clientSecret: string, intentId: string, body: UpdateIntentRequest) => {
  try {
    const { data } = await client(clientSecret).post(`/v1/pa/payment_intents/${intentId}/update`, {
      ...body,
      request_id: uuid(),
    });

    airTracker.info('updateIntentSuccess', {
      component: COMPONENT_NAME,
      intentId,
      customerId: body.customer?.merchant_customer_id,
    });
    return data;
  } catch (error) {
    airTracker.error('apiError', {
      api: 'updateIntent',
      component: COMPONENT_NAME,
      intentId,
      customerId: body.customer?.merchant_customer_id,
      error,
    });
    throw error;
  }
};

export interface ConfirmIntentPaymentConsent {
  next_triggered_by?: 'merchant' | 'customer';
  terms_of_use?: {
    payment_amount_type?: string;
    min_payment_amount?: number;
  };
}

export interface ConfirmIntentRequest {
  payment_consent_id: string;
  payment_consent?: ConfirmIntentPaymentConsent;
}

export const confirmIntent = async (clientSecret: string, intentId: string, body: ConfirmIntentRequest) => {
  try {
    const { data } = await client(clientSecret, { 'x-api-version': '2024-02-22' }).post(
      `/v1/pa/payment_intents/${intentId}/confirm`,
      {
        ...body,
        request_id: uuid(),
      }
    );

    airTracker.info('confirmIntentSuccess', {
      component: COMPONENT_NAME,
      intentId,
      payment_consent_id: body.payment_consent_id,
    });
    return data;
  } catch (error) {
    airTracker.error('apiError', {
      api: 'confirmIntent',
      component: COMPONENT_NAME,
      intentId,
      payment_consent_id: body.payment_consent_id,
      error,
    });
    throw error;
  }
};
